export default __webpack_public_path__ + "static/media/drift.5ae4c654.svg";